import axios from "axios";
import { authHeader, getValidToken } from "../utils/helper";
import { config } from "../utils/config";

export const getAllRoutePoint = (onSuccess = () => {}) => {
  const apiUrl = config.URL.FETCH_ALL_ROUTE;
  return async () => {
    const token = await getValidToken();
    axios
      .get(
        apiUrl,
        authHeader(token)
      )
      .then((res) => {
        onSuccess(res.data);
      })
      .catch((e) => {
        console.error("There is an error when fetching Rout Points", e);
      });
  };
};
export const getAllRoutePointByMenu = (menu,onSuccess = () => {}) => {
  const apiUrl = `${config.URL.GET_ROUTE_BY_MENU}${menu}`;
  return async () => {
    const token = await getValidToken();
    axios
      .get(
        apiUrl,
        authHeader(token)
      )
      .then((res) => {
        onSuccess(res.data);
      })
      .catch((e) => {
        console.error("There is an error when fetching Rout Points", e);
      });
  };
};
export const addWayPoint = (wayPoint, onSuccess) => {
  const apiUrl = config.URL.ADD_WAY_POINT;
  console.log(wayPoint);
  return async () => {
    const token = await getValidToken();
    axios
      .post(
       apiUrl,
        wayPoint,
        authHeader(token)
      )
      .then((res) => {
        onSuccess(res.data);
      })
      .catch((e) => {
        console.error("There is an error when add waypoint", e);
      });
  };
};
export const removeWayPoint = (locationId, onSuccess = () => {}) => {
  const apiUrl = `${config.URL.REMOVE_WAY_POINT}${locationId}`;
  return async () => {
    const token = await getValidToken();
    axios
      .patch(
        apiUrl,
        {},
        authHeader(token)
      )
      .then((res) => {
        onSuccess(res.data);
      })
      .catch((error) => {
        console.error("This is for an error in delete way point", error);
      });
  };
};
export const deleteWayPoint = (locationId, onSuccess = () => {}) => {
  const apiUrl = `${config.URL.DELETE_WAY_POINT}${locationId}`;
  return async () => {
    const token = await getValidToken();
    axios
      .delete(
        apiUrl,
        authHeader(token)
      )
      .then((res) => {
        onSuccess(res.data);
      })
      .catch((error) => {
        console.error("This is for an error in delete way point", error);
      });
  };
};
export const updateWayPoint = (WayPoint, onSuccess = () => {}) => {
  const apiUrl = config.URL.UPDATE_WAY_POINT;
  return async () => {
    const token = await getValidToken();
    axios
      .put(
        apiUrl,
        WayPoint,
        authHeader(token)
      )
      .then((res) => {
        onSuccess(res.data);
      })
      .catch((e) => {
        console.error("There is an error when you update way point", e);
      });
  };
};
